/* eslint-disable import/prefer-default-export */
import axios from "../Axios";
import { saveAs } from "file-saver";

const module = "/partners";

export const uploadMasivePartners = async (formData) => {
  const { data } = await axios.post(`${module}/upload-masive/`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
};

export const getPartners = async (filtersPartners, page = 0, limit = 6) => {
  const {
    search,
    startDate,
    endDate,
    grade,
    state,
    from,
    partnerCreationType,
  } = filtersPartners;
  const { data } = await axios.get(`${module}`, {
    params: {
      search,
      page,
      limit,
      startDate,
      endDate,
      grade,
      from,
      state,
      partnerCreationType,
    },
  });
  return data;
};

export const getPartnersWithFamilyMembers = async (
  filtersPartners,
  page = 0,
  limit = 6,
) => {
  const { search, relationship } = filtersPartners;
  const { data } = await axios.get(
    `${module}/family-members/?search=${search}&page=${page}&limit=${limit}&relationship=${relationship}`,
  );
  return data;
};

export const getPartnersById = async (partnerId) => {
  const { data } = await axios.get(`${module}/${partnerId}`);
  return data;
};

export const createNewPartner = async (formData) => {
  const { data } = await axios.post(`${module}/`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
};

export const updatePartner = async ({ partnerId, formData }) => {
  const { data } = await axios.patch(`${module}/${partnerId}`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
};

export const updatePartnerHierarchy = async ({ partnerId, fields }) => {
  const { data } = await axios.patch(`${module}/${partnerId}/hierarchy`, fields);
  return data;
};

export const addResignationPartner = async ({ partnerId, formData }) => {
  console.log("partnerId", partnerId);
  const { data } = await axios.patch(
    `${module}/${partnerId}/add-resignation`,
    formData,
    {
      headers: { "Content-Type": "multipart/form-data" },
    },
  );
  return data;
};

export const deletePartner = async (partnerId) => {
  const { data } = await axios.delete(`${module}/${partnerId}`);
  return data;
};

export const exportPartners = async (body) => {
  const response = await axios.post(`${module}/report`, body, {
    responseType: "arraybuffer",
  });
  const dirtyFileName = response.headers["content-disposition"];
  const regex =
    /filename[^;=\n]*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/;
  const fileName = dirtyFileName.match(regex)[3];

  const blob = new Blob([response.data], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  saveAs(blob, fileName);

  return response;
};
